import React from 'react';
import AdminSkillGroupListContainer from '@src/components/administrationskills/AdminSkillGroupListContainer';

const AdminSkillGroupListPage = () => <AdminSkillGroupListContainer />;

export default AdminSkillGroupListPage;
